import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Grid,
  Button,
  TextField,
  MenuItem,
  CircularProgress,
} from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import ApiClient from "utils/ApiClient";
import styled from "styled-components";

export const SMTPModal = ({ accountModalData, setAccountModalData, showAlert, store }) => {
  const [smtpData, setSmtpData] = useState({
    name: "",
    email: "",
    hostname: "",
    port: "",
    username: "",
    password: "",
    securityProtocol: "None",
    loading: false,
  });

  const inputFields = [
    { id: "name", label: "Name", type: "text" },
    { id: "email", label: "Email", type: "email" },
    { id: "hostname", label: "Hostname", type: "text" },
    { id: "port", label: "Port", type: "number" },
    { id: "username", label: "Username", type: "text" },
    { id: "password", label: "Password", type: "password" },
  ];

  const securityProtocols = ["None", "SSL", "TLS"];

  const add = () => {
    if (
      smtpData.name.length <= 0 ||
      smtpData.email.length <= 0 ||
      smtpData.hostname.length <= 0 ||
      smtpData.port.length <= 0 ||
      smtpData.username.length <= 0 ||
      smtpData.password.length <= 0
    ) {
      showAlert("Please fill all the fields", false);
      return;
    } else {
      const body = {};
      body.name = smtpData.name;
      body.email = smtpData.email;
      body.hostname = smtpData.hostname;
      body.port = smtpData.port;
      body.username = smtpData.username;
      body.password = smtpData.password;
      body.ssl = smtpData.securityProtocol;
      body.list_id = store.listId;
      body.is_web = 1;
      submitForm(body);
    }
  };

  const submitForm = async (body) => {
    setSmtpData({ ...smtpData, loading: true });
    try {
      const data = await ApiClient.MailMerge.addSmptAccount(body);
      if (data.success) {
        showAlert("Success", true);
      } else {
        showAlert(data.msg ? data.msg : "Something Went Wrong", false);
      }
    } catch (error) {
      // console.log(error)
      showAlert("Something went wrong.Please try again later.", false);
    }
    setSmtpData({ ...smtpData, loading: false });
    setAccountModalData({ ...accountModalData, showSMTPModal: false });
  };

  return (
    <Modal
      open={accountModalData.isSMTPModal}
      onClose={() => setAccountModalData({ ...accountModalData, isSMTPModal: false })}
    >
      <StyledBox>
        <StyledGrid container alignItems="center">
          <Grid item>
            <Typography variant="h4">Add SMTP Account</Typography>
          </Grid>
          <Grid item style={{ flex: "1" }}></Grid>
          <Grid item>
            <Close
              onClick={() => setAccountModalData({ ...accountModalData, isSMTPModal: false })}
              style={{ color: "white" }}
            />
          </Grid>
        </StyledGrid>
        <Grid container direction="column" style={{ padding: "10px" }}>
          {inputFields.map((field) => {
            return (
              <StyledGridItem key={field.label} item>
                <TextField
                  variant="outlined"
                  id="outlined-basic"
                  fullWidth
                  label={field.label}
                  type={field.type}
                  value={smtpData[field.id]}
                  onChange={(e) => setSmtpData({ ...smtpData, [field.id]: e.target.value })}
                  required
                />
              </StyledGridItem>
            );
          })}
          <StyledGridItem item>
            <TextField
              select
              variant="outlined"
              id="outlined-basic"
              fullWidth
              label="Security Protocol"
              value={smtpData.securityProtocol}
              onChange={(e) => setSmtpData({ ...smtpData, securityProtocol: e.target.value })}
            >
              {securityProtocols.map((option) => {
                return (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                );
              })}
            </TextField>
          </StyledGridItem>
          <Grid container justify="flex-end">
            <Button disabled={smtpData.loading} onClick={add} style={{ margin: "5px 5px" }} variant="contained" color="primary">
              Add
              {smtpData.loading && (
                <Box style={{ display: "flex", margin: "0 0 0 10px" }}>
                  <CircularProgress size={24} />
                </Box>
              )}
            </Button>
          </Grid>
        </Grid>
      </StyledBox>
    </Modal>
  );
};

export default SMTPModal;

const StyledBox = styled(Box)`
  && {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    border-radius: 5px;
    min-width: 500px;
    box-shadow: 0.5px 1px 25px 0.5px rgba(0, 0, 0, 0.3);
  }
`;

const StyledGrid = styled(Grid)`
  && {
    padding: 10px 10px 10px 10px;
    background-color: #404040;
    color: white;
  }
`;

const StyledGridItem = styled(Grid)`
  && {
    margin: 5px 0px;
    flex: 1;
  }
`;